export default "/images/vendor/flag-icon-css/flags/4x3/rs.svg?feac46175cdeca2edc96bcc18bf1f347";